import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-responsive-bs4';
import { WidthFull } from '@mui/icons-material';

function DataTable() {
    const [formError, setFormError] = useState({
        city_name: "",
    })


    const stockList = [
        {
            Description: "Description-1",
            item_price: "item_price-1",
            last_stock: "last_stock-1",
            new_stock: "new_stock-1"
        },
        {
            Description: "Description-2",
            item_price: "item_price-2",
            last_stock: "last_stock-2",
            new_stock: "new_stock-2"
        },
        {
            Description: "Description-3",
            item_price: "item_price-3",
            last_stock: "last_stock-3",
            new_stock: "new_stock-3"
        },
        {
            Description: "Description-4",
            item_price: "item_price-4",
            last_stock: "last_stock-4",
            new_stock: "new_stock-4"
        },
        {
            Description: "Description-5",
            item_price: "item_price-5",
            last_stock: "last_stock-5",
            new_stock: "new_stock-5"
        },
        {
            Description: "Description-6",
            item_price: "item_price-6",
            last_stock: "last_stock-6",
            new_stock: "new_stock-6"
        },
        {
            Description: "Description-7",
            item_price: "item_price-7",
            last_stock: "last_stock-7",
            new_stock: "new_stock-7"
        },
        {
            Description: "Description-8",
            item_price: "item_price-8",
            last_stock: "last_stock-8",
            new_stock: "new_stock-8"
        },
        {
            Description: "Description-9",
            item_price: "item_price-9",
            last_stock: "last_stock-9",
            new_stock: "new_stock-9"
        },
        {
            Description: "Description-10",
            item_price: "item_price-10",
            last_stock: "last_stock-10",
            new_stock: "new_stock-10"
        },
        {
            Description: "Description-11",
            item_price: "item_price-11",
            last_stock: "last_stock-11",
            new_stock: "new_stock-11"
        },
        {
            Description: "Description-12",
            item_price: "item_price-12",
            last_stock: "last_stock-12",
            new_stock: "new_stock-12"
        },
        {
            Description: "Description-13",
            item_price: "item_price-13",
            last_stock: "last_stock-13",
            new_stock: "new_stock-13"
        },
        {
            Description: "Description-14",
            item_price: "item_price-14",
            last_stock: "last_stock-14",
            new_stock: "new_stock-14"
        },
        {
            Description: "Description-15",
            item_price: "item_price-15",
            last_stock: "last_stock-15",
            new_stock: "new_stock-15"
        },
        {
            Description: "Description-16",
            item_price: "item_price-16",
            last_stock: "last_stock-16",
            new_stock: "new_stock-16"
        },
        {
            Description: "Description-17",
            item_price: "item_price-17",
            last_stock: "last_stock-17",
            new_stock: "new_stock-17"
        },
        {
            Description: "Description-18",
            item_price: "item_price-18",
            last_stock: "last_stock-18",
            new_stock: "new_stock-18"
        },
        {
            Description: "Description-19",
            item_price: "item_price-19",
            last_stock: "last_stock-19",
            new_stock: "new_stock-19"
        },
        {
            Description: "Description-20",
            item_price: "item_price-20",
            last_stock: "last_stock-20",
            new_stock: "new_stock-20"
        },
        {
            Description: "Description-21",
            item_price: "item_price-21",
            last_stock: "last_stock-21",
            new_stock: "new_stock-21"
        },
        {
            Description: "Description-22",
            item_price: "item_price-22",
            last_stock: "last_stock-22",
            new_stock: "new_stock-22"
        },
        {
            Description: "Description-23",
            item_price: "item_price-23",
            last_stock: "last_stock-23",
            new_stock: "new_stock-23"
        },
        {
            Description: "Description-24",
            item_price: "item_price-24",
            last_stock: "last_stock-24",
            new_stock: "new_stock-24"
        },
        {
            Description: "Description-25",
            item_price: "item_price-25",
            last_stock: "last_stock-25",
            new_stock: "new_stock-25"
        },
        {
            Description: "Description-26",
            item_price: "item_price-26",
            last_stock: "last_stock-26",
            new_stock: "new_stock-26"
        },
        {
            Description: "Description-27",
            item_price: "item_price-27",
            last_stock: "last_stock-27",
            new_stock: "new_stock-27"
        },
        {
            Description: "Description-28",
            item_price: "item_price-28",
            last_stock: "last_stock-28",
            new_stock: "new_stock-28"
        },
        {
            Description: "Description-29",
            item_price: "item_price-29",
            last_stock: "last_stock-29",
            new_stock: "new_stock-29"
        },
        {
            Description: "Description-30",
            item_price: "item_price-30",
            last_stock: "last_stock-30",
            new_stock: "new_stock-30"
        },
        {
            Description: "Description-31",
            item_price: "item_price-31",
            last_stock: "last_stock-31",
            new_stock: "new_stock-31"
        },
        {
            Description: "Description-32",
            item_price: "item_price-32",
            last_stock: "last_stock-32",
            new_stock: "new_stock-32"
        },
        {
            Description: "Description-33",
            item_price: "item_price-33",
            last_stock: "last_stock-33",
            new_stock: "new_stock-33"
        },
        {
            Description: "Description-34",
            item_price: "item_price-34",
            last_stock: "last_stock-34",
            new_stock: "new_stock-34"
        },
        {
            Description: "Description-35",
            item_price: "item_price-35",
            last_stock: "last_stock-35",
            new_stock: "new_stock-35"
        },
        {
            Description: "Description-36",
            item_price: "item_price-36",
            last_stock: "last_stock-36",
            new_stock: "new_stock-36"
        },
        {
            Description: "Description-37",
            item_price: "item_price-37",
            last_stock: "last_stock-37",
            new_stock: "new_stock-37"
        },
        {
            Description: "Description-38",
            item_price: "item_price-38",
            last_stock: "last_stock-38",
            new_stock: "new_stock-38"
        },
        {
            Description: "Description-39",
            item_price: "item_price-39",
            last_stock: "last_stock-39",
            new_stock: "new_stock-39"
        },
        {
            Description: "Description-40",
            item_price: "item_price-40",
            last_stock: "last_stock-40",
            new_stock: "new_stock-40"
        },

    ];

    console.log(stockList)

    useEffect(() => {
        const tableId = '#example2';
        const table = $(tableId);

        // Destroy any existing DataTable instance before initializing a new one
        if ($.fn.DataTable.isDataTable(tableId)) {
            table.DataTable().destroy();
        }

        // Initialize DataTable with scrollX for horizontal scrolling
        table.DataTable({
            paging: true,
            lengthChange: true,
            searching: true,
            ordering: true,
            info: true,
            autoWidth: false,
            scrollX: true,  // Enable horizontal scrolling
            pageLength: 5,
            lengthMenu: [5, 10, 15, 20],
            buttons: ['copy', 'excel', 'pdf', 'print'],
            dom: 'Bfrtip'
        });

        // Cleanup to destroy DataTable on component unmount
        return () => {
            if ($.fn.DataTable.isDataTable(tableId)) {
                table.DataTable().destroy();
            }
        };
    }, [stockList]);



    const handle_submit = () => {

    };

    const clearError = () => {
        const clearedErrors = {};

        Object.keys(formError).forEach(field => {
            clearedErrors[field] = "";
        });

        setFormError(clearedErrors);
    }


    return (

        // data table
        // <div style={{ overflowX: 'auto' }}>
        //     <div className="card">
        //         <div className="card-header">
        //             <h3 className="card-title">Stock List</h3>
        //         </div>
        //         <div className="card-body">
        //             <table id="example2" className="table table-bordered table-hover" style={{ width: '100%' }}>
        //                 <thead>
        //                     <tr>
        //                         <th>#</th>
        //                         <th>Description</th>
        //                         <th>Item Price</th>
        //                         <th>Last Stock</th>
        //                         <th>New Stock</th>
        //                     </tr>
        //                 </thead>
        //                 <tbody>
        //                     {
        //                         stockList.map((stock, index) => (
        //                             <tr key={index}>
        //                                 <td>{index + 1}</td>
        //                                 <td>{stock.Description}</td>
        //                                 <td>{stock.item_price}</td>
        //                                 <td>{stock.last_stock}</td>
        //                                 <td>{stock.new_stock}</td>
        //                             </tr>
        //                         ))
        //                     }
        //                 </tbody>
        //             </table>
        //         </div>
        //     </div>
        // </div>

        // form validation
        <div className="container mt-5">
            <div className="row">
                <div className="col-8">
                    <form action=""
                        className=''
                    >
                        <table className=''>
                            <tbody>
                                <tr>
                                    <th>
                                        <label htmlFor="name">Name:</label>
                                    </th>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control'
                                            placeholder='Enter Name'
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label htmlFor="name">Email:</label>
                                    </th>
                                    <td>
                                        <input
                                            type="email"
                                            className='form-control'
                                            placeholder='Enter Email'
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label htmlFor="name">Mobile No:</label>
                                    </th>
                                    <td>
                                        <input
                                            type="mobile_no"
                                            className='form-control'
                                            placeholder='Enter Mobile No'
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <button
                                            onClick={handle_submit}
                                            className='btn btn-naariyal-green'
                                        >
                                            Submit
                                        </button>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </form>
                </div>
            </div>
        </div>



    );
}

export default DataTable;